module.exports = __webpack_public_path__ + "img/uid-guide.38a2814.jpg";